//------------------------------------------------------------------------------
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
//------------------------------------------------------------------------------  
enum UserRole {

  None = 0,

  Admin = 1,

}

export default UserRole;